import { useState, useCallback } from 'react';

export default () => {
  const [agents, setAgents] = useState<API.CSRAgent[]>([]);
  const [selectedAgent, setSelectedAgent] = useState<API.CSRAgent | null>(null);

  const updateAgent = useCallback((agentId: number, updates: Partial<API.CSRAgent>) => {
    setAgents((prev) =>
      prev.map((agent) => (agent.id === agentId ? { ...agent, ...updates } : agent)),
    );
    if (selectedAgent?.id === agentId) {
      setSelectedAgent((prev) => (prev ? { ...prev, ...updates } : null));
    }
  }, [selectedAgent]);

  const addAgent = useCallback((agent: API.CSRAgent) => {
    setAgents((prev) => [...prev, agent]);
  }, []);

  const removeAgent = useCallback((agentId: number) => {
    setAgents((prev) => prev.filter((agent) => agent.id !== agentId));
    if (selectedAgent?.id === agentId) {
      setSelectedAgent(null);
    }
  }, [selectedAgent]);

  return {
    agents,
    selectedAgent,
    setAgents,
    setSelectedAgent,
    updateAgent,
    addAgent,
    removeAgent,
  };
};

